'use strict';

angular.module('shiftTraderApp')
    .directive('saMassDepartmentEditor', function () {
      return {
        templateUrl: 'views/directives/saMassDepartmentEditor.html',
        restrict: 'A',
        scope: {
          me:'=loggedInUser',
          org:'=',
          allDepartments: '=',
          newDepartments: '='
        },
        controller: ['$scope', '$timeout', 'Departments', 'toastr', function($scope, $timeout, Departments, toastr) {

          var focusNameInput = function(timeout) {
            if (_.isNull(timeout)) {
              timeout = 0;
            }
            $timeout(
              function() {
                $('#dept-name').focus();
              }, timeout);
          };

          var init = function() {
            _.each($scope.newDepartments, function(dept) {
              var realDept = _.find($scope.allDepartments, {id: dept.id});
              if (!_.isUndefined(realDept)) {
                var idx = _.findIndex($scope.newDepartments, {id: dept.id});
                $scope.newDepartments[idx] = realDept;
              }
            });
            removeWarning();
            focusNameInput(1000);
            $timeout(calculateWrapperSize, 0);
          };

          var removeWarning = function() {
            $scope.warningDept = {
              id: -1
            };
          };


          var hasActivePositions = function(dept) {
            return _.where(dept.positions, { active: true }).length;
          };

          var isUniqueDeptName = function(dept) {
            return _.isUndefined(_.find($scope.allDepartments, {name: dept.name}));
          };

          $scope.warningActive = function() {
            return $scope.warningDept.id > -1;
          };

          $scope.newDepartment = {
            name: ''
          };

          var clearDeptForm = function() {
            $scope.newDepartment.name = '';
            $scope.dept_editor_form.$setPristine();
            focusNameInput();
          };

          var calculateWrapperSize = function () {
            // Set width of list wrapper based on max number of cards that can fit
            var listWidth = $('.dept_editor_dept_list_outer_wrapper').width();

            //  width + margin of emp_ card_wrapper
            var cardWidth = $('.dept_card_wrapper').width();
            var minCardMargin = 5;

            var wrapperWidth = listWidth - 2*minCardMargin;
            $scope.numCardsPerRow = Math.floor(wrapperWidth / (2*minCardMargin + cardWidth));
            var cardMargin = (wrapperWidth - $scope.numCardsPerRow*cardWidth) / (2*$scope.numCardsPerRow);

            $('.dept_editor_dept_list_wrapper').css('width', wrapperWidth);
            $('.dept_card_wrapper').css({'margin-left': cardMargin, 'margin-right': cardMargin});
          };

          $scope.addDepartment = function() {
            removeWarning();
            var data = {
              organization_id: $scope.org.id,
              name: $scope.newDepartment.name
            };
            if (isUniqueDeptName(data)) {
              Departments.create(data)
                  .then(function (responseData) {
                    $scope.newDepartments.splice(0, 0, responseData);
                    $scope.allDepartments.splice(0, 0, responseData);
                    toastr.success('Department ' + responseData.name + ' created.', 'Success');
                    clearDeptForm();
                    $timeout(calculateWrapperSize, 0);
                  }, function () {
                    toastr.error('Department ' + data.name + ' creation failed. Try again later.', 'Error');
                  });
            } else {
              toastr.error('Department ' + data.name + ' already exists.', 'Error');
            }
          };

          $scope.removeDepartment = function(dept) {
//            var realDept = _.find($scope.allDepartments, {id: dept.id});
            if (hasActivePositions(dept)) {
              $scope.warningDept = dept;
              focusNameInput();
            } else {
              removeWarning();
              focusNameInput();
              dept.$makeInactive()
                  .then(function () {
                    _.remove($scope.newDepartments, function (oldDept) {
                      return oldDept.id === dept.id;
                    });
                    _.remove($scope.allDepartments, function (oldDept) {
                      return oldDept.id === dept.id;
                    });
                    toastr.success('Department "' + dept.name + '" deleted.', 'Success');
                  }, function () {
                    toastr.error('"' + dept.name + '" could not be deleted. Please try again.', 'Error');
                  });
            }
          };

          $scope.newDepartmentsEmpty = function() {
            return _.isUndefined(_.find($scope.newDepartments, {active: true}));
          };

          init();

        }]
      };
    });
